let Slider;
export default () => ({
	id: '',
	section_id: '',
	intent: '',
	limit: null,
	// container: document.querySelector(`.product-recommendation-main-${this.section_id}`),

	async getRecommendedProducts() {
		const url = `${window.routes.recommendations}?section_id=${this.section_id}&product_id=${this.id}&limit=${this.limit}&intent=${this.intent}`;
		const response = await fetch(url);
		if (response.status !== 200) return;

		const html = await response.text();
		const parser = new DOMParser().parseFromString(html, 'text/html');
		const product_list = parser.querySelector(`.product-recommendation-main-${this.section_id}`);

		document.querySelector(`.product-recommendation-main-${this.section_id}`).innerHTML =
			product_list.innerHTML;
		this.createSlider();
	},

	createSlider() {
		const container = document.querySelector(`.related-products__container-${this.section_id}`);
		const slider_el = document.querySelector(`.related-products__products-${this.section_id}`);
		if (!slider_el) return;
		const slides = slider_el.querySelectorAll('.product-card');
		if (slides.length > 3 && slides.length < 5) {
			container.classList.add('size-4');
			Slider = new window.Swiper(`.related-products__products-${this.section_id}`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: 10,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1280: {
						enabled: false,
						slidesPerView: 'auto',
					},
				},
				navigation: {
					nextEl: `.next-slide-${this.section_id}`,
					prevEl: `.prev-slide-${this.section_id}`,
				},
				pagination: {
					el: `.related-products__pagination-${this.section_id}`,
					type: 'progressbar',
				},
			});
		} else if (slides.length < 4) {
			container.classList.add('size-3');
			Slider = new window.Swiper(`.related-products__products-${this.section_id}`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: 10,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.next-slide-${this.section_id}`,
					prevEl: `.prev-slide-${this.section_id}`,
				},
				pagination: {
					el: `.related-products__pagination-${this.section_id}`,
					type: 'progressbar',
				},
			});
		} else if (slides.length == 5) {
			container.classList.add('size-5');
			Slider = new window.Swiper(`.related-products__products-${this.section_id}`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: 10,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.next-slide-${this.section_id}`,
					prevEl: `.prev-slide-${this.section_id}`,
				},
				pagination: {
					el: `.related-products__pagination-${this.section_id}`,
					type: 'progressbar',
				},
			});
		} else if (slides.length > 5) {
			Slider = new window.Swiper(`.related-products__products-${this.section_id}`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: 10,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 5,
					},
				},
				navigation: {
					nextEl: `.next-slide-${this.section_id}`,
					prevEl: `.prev-slide-${this.section_id}`,
				},
				pagination: {
					el: `.related-products__pagination-${this.section_id}`,
					type: 'progressbar',
				},
			});
		}
	},

	init() {
		this.$watch('section_id', () => {
			this.getRecommendedProducts();
		});
	},
});
